import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

type Ctx = {
    isOpen: boolean;
    open: () => void;
    close: () => void;
};

const SubscribeModalContext = createContext<Ctx | null>(null);

export const SubscribeModalProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);

    const open = useCallback(() => setIsOpen(true), []);
    const close = useCallback(() => setIsOpen(false), []);

    const value = useMemo(() => ({ isOpen, open, close }), [isOpen, open, close]);

    return (
        <SubscribeModalContext.Provider value={value}>{children}</SubscribeModalContext.Provider>
    );
};

export function useSubscribeModal() {
    const ctx = useContext(SubscribeModalContext);
    if (!ctx) throw new Error('useSubscribeModal must be used within <SubscribeModalProvider>');
    return ctx;
}
